import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ResultGrid from './ResultGrid';
import { errorLines } from '../utils/errorLines';
import styles from './MainDisplayTabs.module.css'; // 스타일은 MainDisplayTabs의 것을 공유하거나 별도 파일로 분리 가능

const QueryResultContent = ({ activeTab, onFetchMoreData, columnComments = {}, isCompactGrid = false, showUserComments = false, gridFormat, onPasteToEditor }) => {
    const { t } = useTranslation();
    const resultGridRef = useRef(null);

    if (!activeTab) {
        return <div className={styles.noTabsMessage}>{t('common:qrc.noTab')}</div>;
    }

    // **실행 중에는 그 사실을 말한다.** 예전에는 아직 아무것도 못 받은 상태가 빈 결과와 구별되지 않아
    // 돌고 있는 쿼리에 대고 「조회 결과가 없습니다 (0건)」 을 띄웠다 — 끝난 줄 알고 다시 실행하게 된다.
    // 제한시간을 없앤 뒤로는 이 표시가 더 중요해졌다(오래 걸리는 것이 정상일 수 있다).
    if (activeTab.isExecuting && (!activeTab.data || activeTab.data.length === 0) && !activeTab.error) {
        return (
            <div className={styles.subTabsContent} style={{ flex: '1 1 0', minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                <div className={styles.runningMessage}>
                    <span className={styles.runningSpinner} />
                    {t('common:qrc.running')}
                </div>
            </div>
        );
    }

    return (
        <div className={styles.subTabsContent} style={{ flex: '1 1 0', minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            {activeTab.error && (
                <div className={styles.queryErrorBanner}>
                    {/* 오류 스택은 코드(ORA-…)마다 한 줄 — 한 줄로 퍼지면 읽기 어렵다. 첫 줄이 원인이고 나머지는 호출 위치다 */}
                    <strong>{t('common:qrc.error')}</strong>
                    <div className={styles.queryErrorLines}>
                        {errorLines(activeTab.error).map((line, i) => (
                            // eslint-disable-next-line react/no-array-index-key -- 오류 글의 줄은 순서가 곧 정체다
                            <div key={i} className={i === 0 ? styles.queryErrorMain : styles.queryErrorTrace}>{line}</div>
                        ))}
                    </div>
                </div>
            )}
            <div ref={resultGridRef} style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0, minWidth: 0 }}>
              <ResultGrid
                results={activeTab.data}
                columnsMeta={activeTab.columns}
                onFetchMoreData={onFetchMoreData}
                hasMore={activeTab.hasMore}
                isLoadingMore={activeTab.isLoadingMore}
                tabId={activeTab.id}
                loadingMessage={activeTab.loadingMessage}
                canRetry={activeTab.canRetry}
                hasError={!!activeTab.error}
                startRowIndex={activeTab.startRowIndex || 0}
                columnComments={columnComments}
                message={activeTab.message}
                isCompactGrid={isCompactGrid}
                showUserComments={showUserComments}
                connectionId={activeTab.connectionId || null}
                gridFormat={gridFormat}
                onPasteToEditor={onPasteToEditor}
              />
            </div>
            {activeTab.isLoadingMore && activeTab.data && activeTab.data.length > 0 && (
                <div className={styles.loadingMoreIndicator}>{t('common:qrc.loadingMore')}</div>
            )}
            {activeTab.isLoadingMore && (!activeTab.data || activeTab.data.length === 0) && !activeTab.error && (
                <div className={styles.loadingMessage}>{t('common:qrc.loading')}</div>
            )}
        </div>
    );
};

QueryResultContent.propTypes = {
    activeTab: PropTypes.object,
    onFetchMoreData: PropTypes.func.isRequired,
};

export default QueryResultContent; 